import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Navbar, Modal } from "react-bootstrap";
import "./styles.css";
import Footer from './../Footer';
import { motion } from "framer-motion";
import { ChartNoAxesCombined, Landmark, ReceiptIndianRupee, Star, IndianRupee, Banknote, Handshake, CalendarClock } from "lucide-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoNotifications } from "react-icons/io5";
import { Gauge } from '@mui/x-charts/Gauge';
import { Player } from '@lottiefiles/react-lottie-player';
import { AuthContext } from './../AuthContext';
import axios from 'axios';
import { site_url, site_url_img } from "../config.js";
import { parseStoredAccessToken } from "../parseStoredAccessToken.js";
import { parseWalletAmount } from "../parseWalletAmount.js";
import { FormatDate } from "../Function";
import { encryptReferralRef } from "../referralRefCrypto.js";
import { FaAngleRight } from "react-icons/fa";

import { Link, Navigate, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';


function Index({ children }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [welcomeShow, setwelcomeShow] = useState(false);
  const { user, fulluser } = useContext(AuthContext);
  const [UserActivity, setUserActivity] = useState(null);
  const [paymentdetails, setpaymentdetails] = useState([]);
  const [Withdraw, setWithdraw] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [categorydata, setcategorydata] = useState([]);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [bankAccount, setBankAccount] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [bankName, setBankName] = useState('');
  const [upiId, setUpiId] = useState('');
  const [preferredMethod, setPreferredMethod] = useState('bank');
  const [bankDetails, setBankDetails] = useState(null);
  const [useSavedDetails, setUseSavedDetails] = useState(true);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [showWithdrawHistory, setShowWithdrawHistory] = useState(false);

  // Email Verification State
  const EMAIL_VERIFY_REMIND_KEY = 'email_verify_remind_later_at';
  const EMAIL_VERIFY_REMIND_MS = 60 * 60 * 1000; // 1 hour
  const [showEmailVerify, setShowEmailVerify] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailVerifyMsg, setEmailVerifyMsg] = useState({ type: '', text: '' });
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const [newEmail, setNewEmail] = useState('');
  const [isUpdatingEmail, setIsUpdatingEmail] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setIsChecked2(e.target.checked);
    console.log('Reward Wallet Checked:', e.target.checked);
  };


  const games = [
    {
      name: "Mile Stone",
      icon: "https://pngimg.com/d/target_PNG30.png",
      reward: 100,
      bg: "radial-gradient(circle, rgb(16 198 184) 61%, rgb(10 136 153) 111%)"
    },

  ];
  const shareReferralLink = async () => {
    let referralLink;
    try {
      const refToken = await encryptReferralRef(String(fulluser?.id ?? ''));
      referralLink = `${window.location.origin}/signup?ref=${encodeURIComponent(refToken)}`;
    } catch (err) {
      console.error('Referral link encrypt failed', err);
      alert('Could not create referral link. Please try again.');
      return;
    }

    const isInReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';

    if (navigator.share && !isInReactNativeWebView) {
      navigator
        .share({
          title: 'Join with my referral link!',
          text: 'Sign up now and get a bonus!',
          url: referralLink,
        })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.error('Sharing failed', error));
    } else if (isInReactNativeWebView) {
      // Send referralLink to React Native
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'SHARE_REFERRAL',
        url: referralLink,
      }));
    } else {
      alert('Your device does not support native sharing.');
    }
  };



  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_details", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserActivity(res.data);

            // Check Device Token for Single Session
            const storedDeviceToken = localStorage.getItem('device_token');
            const remoteDeviceToken = res.data.data?.user_details?.device_token;

            if (storedDeviceToken && remoteDeviceToken && storedDeviceToken !== remoteDeviceToken) {
              setShowLogoutModal(true);
              return;
            }

            // Check Email Verification
            // If email is missing OR email is present but not verified, show popup only if not dismissed in last 1 hr
            if (!res.data.data?.user_details?.email || !res.data.data?.user_details?.email_verified_at) {
              const remindLaterAt = localStorage.getItem(EMAIL_VERIFY_REMIND_KEY);
              const shouldShow = !remindLaterAt || (Date.now() - parseInt(remindLaterAt, 10)) >= EMAIL_VERIFY_REMIND_MS;
              if (shouldShow) {
                // setShowEmailVerify(true);
                // Pre-fill newEmail if it exists, so user can edit it if they want
                if (res.data.data?.user_details?.email) {
                  setNewEmail(res.data.data.user_details.email);
                }
              }
            }

          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response?.data);
          if (err.response?.status === 401) {
            navigate('/signin');
          }
        });
    }
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleSendEmailOtp = async () => {
    const token = parseStoredAccessToken(user);
    try {
      setEmailVerifyMsg({ type: 'info', text: 'Sending OTP...' });

      const payload = {};
      // If updating email or email was previously null
      if (newEmail && newEmail !== UserActivity?.data?.user_details?.email) {
        payload.email = newEmail;
      } else if (!UserActivity?.data?.user_details?.email && newEmail) {
        payload.email = newEmail;
      }

      const res = await axios.post(site_url + '/send_email_verify_otp', payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 'success') {
        setEmailOtpSent(true);
        setEmailVerifyMsg({ type: 'success', text: 'OTP sent to your email.' });
        setTimer(60); // Start 60s timer
        setCanResend(false);
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Failed to send OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: err?.response?.data?.message || 'Error sending OTP.' });
    }
  };

  const handleVerifyEmailOtp = async () => {
    const token = parseStoredAccessToken(user);
    try {
      const res = await axios.post(site_url + '/verify_email_otp', { otp: emailOtp }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 'success') {
        // setShowEmailVerify(false);
        setShowSuccessModal(true);
        getUserdetails(); // Refresh data
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Invalid OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: 'Verification failed.' });
    }
  };

  useEffect(() => {
    getUserdetails();
    if (user) {
      getWithdrawalHistory();
      fetchBankDetails();
    }
  }, [user]);

  // Fetch saved bank/UPI details
  const fetchBankDetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      try {
        const res = await axios.get(site_url + "/bank-details", {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        });
        if (res.data.status === 'success' && res.data.data) {
          setBankDetails(res.data.data);
          // Pre-fill form with saved details
          if (res.data.data.preferred_method === 'bank') {
            setAccountHolderName(res.data.data.account_holder_name || '');
            setBankAccount(res.data.data.bank_account || '');
            setIfscCode(res.data.data.ifsc_code || '');
            setBankName(res.data.data.bank_name || '');
            setPreferredMethod('bank');
          } else {
            setUpiId(res.data.data.upi_id || '');
            setPreferredMethod('upi');
          }
        }
      } catch (err) {
        console.error("Bank Details Error:", err.response?.data || err.message);
      }
    }
  };

  // Get withdrawal history
  const getWithdrawalHistory = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      try {
        const res = await axios.get(site_url + "/withdrawal-history", {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        });
        if (res.data.status === 'success') {
          setWithdrawalHistory(res.data.data || []);
        }
      } catch (err) {
        console.error("Withdrawal History Error:", err.response?.data || err.message);
      }
    }
  };

  // Handle withdrawal request
  const handleWithdrawal = async () => {
    const token = parseStoredAccessToken(user);
    if (!token) {
      alert('Please login to continue');
      return;
    }

    // Validation
    if (!withdrawAmount || parseFloat(withdrawAmount) <= 0) {
      alert('Please enter a valid withdrawal amount');
      return;
    }

    const amount = parseFloat(withdrawAmount);
    const minWithdrawal = parseWalletAmount(UserActivity?.data?.mini_withdrawal, 10);
    const availableBalance = parseWalletAmount(
      UserActivity?.data?.redemption_total ?? UserActivity?.data?.wallet_balance
    );

    if (amount < minWithdrawal) {
      alert(`Minimum withdrawal amount is ₹${minWithdrawal}`);
      return;
    }

    if (amount > availableBalance) {
      alert(`Insufficient balance. Available: ₹${availableBalance.toFixed(2)}`);
      return;
    }

    // Use saved details or manual entry
    let finalBankAccount, finalIfscCode, finalAccountHolderName, finalUpiId, finalPreferredMethod;

    if (useSavedDetails && bankDetails) {
      finalPreferredMethod = bankDetails.preferred_method || 'bank';
      if (finalPreferredMethod === 'bank') {
        finalBankAccount = bankDetails.bank_account;
        finalIfscCode = bankDetails.ifsc_code;
        finalAccountHolderName = bankDetails.account_holder_name;
      } else {
        finalUpiId = bankDetails.upi_id;
      }
    } else {
      finalPreferredMethod = preferredMethod;
      if (preferredMethod === 'bank') {
        if (!bankAccount || !ifscCode || !accountHolderName) {
          alert('Please fill all bank account details');
          return;
        }
        finalBankAccount = bankAccount;
        finalIfscCode = ifscCode;
        finalAccountHolderName = accountHolderName;
      } else {
        if (!upiId) {
          alert('Please enter UPI ID');
          return;
        }
        finalUpiId = upiId;
      }
    }

    try {
      const res = await axios.post(
        site_url + "/request-withdrawal",
        {
          amount: amount,
          bank_account: finalBankAccount,
          ifsc_code: finalIfscCode,
          account_holder_name: finalAccountHolderName,
          upi_id: finalUpiId,
          preferred_method: finalPreferredMethod,
          use_saved_details: useSavedDetails ? '1' : '0'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        }
      );

      if (res.data.status === 'success') {
        alert('Withdrawal request submitted successfully!');
        setWithdraw(false);
        setWithdrawAmount('');
        if (!useSavedDetails) {
          setBankAccount('');
          setIfscCode('');
          setAccountHolderName('');
          setUpiId('');
        }
        getUserdetails();
        getWithdrawalHistory();
      } else {
        alert(res.data.message || 'Withdrawal request failed. Please try again.');
      }
    } catch (err) {
      console.error("Withdrawal Error:", err.response?.data || err.message);
      alert(err.response?.data?.message || 'Something went wrong. Please try again.');
    }
  };




  useEffect(() => {
    
    if (UserActivity?.data?.bonues_view == 0) {
      setwelcomeShow(true);
    }
  }, [UserActivity]);


  const userpayrequest = async () => {
    const token = parseStoredAccessToken(user);

    if (token) {
      axios.get(site_url + "/userpayrequest", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {

          if (res.data.status == 'success') {
            setShow(true);
            setpaymentdetails(res.data.data);
          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };
  // useEffect(() => {
  //   // userpayrequest();
  //   const interval = setInterval(() => {
  //     userpayrequest();
  //   }, 10000); 

  //   return () => clearInterval(interval); 
  // }, [user]);

  const makePayment = async () => {
    const res = await axios.post(site_url + "/payonlineorder", {
      amount: paymentdetails?.billamount,
      order_id: paymentdetails?.id,
      isChecked: isChecked ? '1' : '0',
      isChecked2: isChecked2 ? '1' : '0'
    });
    if (res.data.status === 'redeem' || res.data.status === 'reedme') {
      setShow(false);
      getUserdetails();
      Swal.fire('Success', 'Bill paid using wallet balance.', 'success');
      return;
    }
    const { razorpay_key, order_id, amount, currency } = res.data;

    const options = {
      key: razorpay_key,
      amount: amount,
      currency: currency,
      name: "APM",
      description: "Test Transaction",
      order_id: order_id,
      handler: async function (response) {
        try {
          const token = parseStoredAccessToken(user); // assuming 'user' contains the token as stringified

          if (token) {
            const activityWalletBalance = parseWalletAmount(
              UserActivity?.data?.wallet_balance
              ?? UserActivity?.data?.redemption_total
            );
            const activityBillAmount = parseFloat(
              paymentdetails?.totalbillamount ?? paymentdetails?.billamount ?? 0
            ) || 0;
            const activityUsedWallet = isChecked
              ? Math.min(activityWalletBalance, activityBillAmount)
              : 0;
            const res = await axios.post(
              site_url + "/verify-payment",
              {
                razorpay_payment_id: response.razorpay_payment_id,
                oid: paymentdetails?.id,
                isChecked: isChecked ? '1' : '0',
                isChecked2: isChecked2 ? '1' : '0',
                used_wallet: activityUsedWallet
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: 'application/json'
                }
              }
            );


            if (res.data.status === 'success') {
              setShow(false);
              getUserdetails();
              Swal.fire('Success', 'Payment verified successfully!', 'success');
            } else {
              Swal.fire('Payment Failed', res.data.message || 'Payment verification failed.', 'error');
            }

          } else {
            console.warn("Token missing");
          }
        } catch (err) {
          console.error("API Error:", err?.response?.data || err.message);
          Swal.fire('Error', 'An error occurred during verification.', 'error');
        }
      },
      prefill: {
        name: fulluser?.username,
        email: "saravanan@example.com",
        contact: fulluser?.phone
      },
      theme: {
        color: "#3399cc"
      },
      modal: {
        ondismiss: function () {
          console.log('Payment modal closed');
        }
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', function (response) {
      Swal.fire('Payment Failed', response.error.description, 'error');
    });
    rzp.open();
  };

  useEffect(() => {
    const shopcategory = async () => {
      try {

        const response = await axios.get(site_url + '/vendor/shopcategory');

        if (response.data.status == 'success') {

          setcategorydata(response.data.category);
        }
      } catch (error) {

      }
    }
    shopcategory();
  }, []);

  return (
    <>
      <Footer />

      <div id="appCapsule">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div>
            <div className='cardbg'>
              <h3 className='text-white headertext'>My Rewards</h3>

            </div>

            <div className="section wallet-card-section pt-1">

              <div className="wallet-card-modern" style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)',
                borderRadius: '24px',
                padding: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                overflow: 'hidden',
                color: '#333',
                marginBottom: '20px',
                border: '1px solid rgba(255,255,255,0.8)'
              }}>

                <div className="balance-info" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
                  <span className="title" style={{
                    fontSize: '13px',
                    fontWeight: '600',
                    color: '#666',
                    letterSpacing: '0.5px',
                    marginBottom: '10px',
                    display: 'block',
                    textTransform: 'uppercase'
                  }}>
                  Coins available for redemption
                  </span>

                  <div className="amount-display" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    margin: '15px 0'
                  }}>

                    <span style={{ fontSize: '24px' }}>🪙</span>
                    <h1 className="total" style={{
                      fontSize: '18px',
                      fontWeight: '800',
                      margin: 0,
                      color: '#333',
                      letterSpacing: '-1px'
                    }}>
                      {parseWalletAmount(UserActivity?.data?.redemption_total).toFixed(2)}
                    </h1>
                  </div>
                </div>

                {/* Payout Button - Points to Bank Account */}
                {/* {user && (
                  <div className="mt-4">
                    <button
                      onClick={() => setWithdraw(true)}
                      className="transfer-action-btn"
                      style={{
                        background: 'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)',
                        border: 'none',
                        borderRadius: '16px',
                        padding: '15px 25px',
                        width: '100%',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 8px 20px rgba(0, 176, 155, 0.3)',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-3px)';
                        e.currentTarget.style.boxShadow = '0 12px 25px rgba(0, 176, 155, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 176, 155, 0.3)';
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '20px', textAlign: 'left', flex: 1 }}>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontSize: '15px', fontWeight: '700', lineHeight: '1.2' }}>🪙Points To Bank Account (Redemption)</span>
                        </div>
                      </div>
                      <div style={{
                        background: 'rgba(255,255,255,0.3)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <FaAngleRight size={16} color="white" />
                      </div>
                    </button>
                  </div>
                )} */}
 <p style={{textAlign:'center',marginTop:'5%',}}><i>🪙 1 Coin= ₹1 (Rupee ONE)</i></p>
                {/* <div className="wallet-footer">
      <div className="item">
        <a href="#" onClick={() => setWithdraw(true)} >
          <div className="icon-wrapper bg-danger">
            <ion-icon name="arrow-down-outline" role="img" className="md hydrated" aria-label="arrow down outline" />
          </div>
          <strong>Withdraw</strong>
        </a>
      </div>
      <div className="item">
        <a href="#" >
          <div className="icon-wrapper">
            <ion-icon name="arrow-forward-outline" role="img" className="md hydrated" aria-label="arrow forward outline" />
          </div>
          <strong>Exchange</strong>
        </a>
      </div>
      <div className="item">
      <a
  href={paymentdetails?.id ? '#' : '#'}
  onClick={paymentdetails?.id ? () => setShow(true) : undefined}
>

          <div className="icon-wrapper bg-success">
            <ion-icon name="card-outline" role="img" className="md hydrated" aria-label="card outline" />
          </div>
          <strong>Pending Bill Payment</strong>
        </a>
      </div>
      
    </div> */}
                {/* * Wallet Footer */}

               
              </div>

            </div>

          </div>
        </motion.div>

        {/* Email Verification Action Sheet Modal */}
        {showEmailVerify && (
          <div
            className="modal fade action-sheet show"
            id="emailVerifyActionSheetUser"
            tabIndex={-1}
            role="dialog"
            style={{ display: 'block' }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Account Security</h5>
                </div>
                <div className="modal-body">
                  <div className="action-sheet-content">
                    <div className="text-center mb-2">
                      <div
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: 'rgba(98, 54, 255, 0.1)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 15px auto'
                        }}
                      >
                        <ion-icon name="mail-unread-outline" style={{ fontSize: '40px', color: '#6236FF' }}></ion-icon>
                      </div>
                    </div>
                    <h3 className="text-center mb-1">Verify Your Email</h3>
                    <p className="text-center mb-3">
                      To ensure you receive monthly statements and important account updates, please verify your email address.
                    </p>

                    <div className="row g-2 mt-3 p-2">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm w-100"
                          onClick={() => {
                            setShowEmailVerify(false);
                            navigate('/Settings');
                          }}
                        >
                          Go to Profile
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                        style={{ height: '100%' }}
                          type="button"
                          className="btn btn-secondary btn-sm w-100"
                          onClick={() => {
                            localStorage.setItem(EMAIL_VERIFY_REMIND_KEY, String(Date.now()));
                            setShowEmailVerify(false);
                          }}
                        >
                          Remind Me Later
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Verification Success Modal */}
        {showSuccessModal && (
          <div
            className="modal fade action-sheet show"
            id="successActionSheet"
            tabIndex={-1}
            role="dialog"
            style={{ display: 'block' }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Success</h5>
                </div>
                <div className="modal-body">
                  <div className="action-sheet-content">
                    <div className="text-center mb-2">
                      <div
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: 'rgba(50, 168, 82, 0.1)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 15px auto'
                        }}
                      >
                        <ion-icon name="checkmark-circle-outline" style={{ fontSize: '40px', color: '#32a852' }}></ion-icon>
                      </div>
                    </div>
                    <h3 className="text-center mb-1">Email Verified!</h3>
                    <p className="text-center mb-3">
                      Your email has been successfully verified. You will now receive monthly statements and important updates.
                    </p>

                    <div className="form-group basic">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg"
                        onClick={() => setShowSuccessModal(false)}
                      >
                        Great!
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Three Cards: Total Points Used, Expired Points, APM Monthly Power */}
        <div className="section mt-2">
          <div className="row">
            {/* Left Box: Total Points Used */}
            <div className="col-4 mt-1">
              <div className="stat-box billamountbonues" style={{ padding: '12px', minHeight: '110px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                {/* <ReceiptIndianRupee size={28} color={'white'} style={{ marginBottom: '8px' }} /> */}
               <img src={'/01fa99.png'} style={{ width: '28px', height: '28px', marginBottom: '8px' }} />
                <div className="bonuestitle" style={{ fontSize: '11px', marginTop: '5px', lineHeight: '1.3' }}>Total Points Used</div>
                <div className="bonuevalue" style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '8px' }}>
                  🪙 {parseWalletAmount(UserActivity?.data?.total_points_used).toFixed(2)}
                </div>
              </div>
            </div>

            {/* Middle Box: Total Points Expired */}
            <div className="col-4 mt-1">
              <Link to="/ExpiredPoints" style={{ textDecoration: 'none' }}>
                <div className="stat-box billamountbonues" style={{ padding: '12px', minHeight: '110px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', cursor: 'pointer' }}>
                <img src={'/01fa99.png'} style={{ width: '28px', height: '28px', marginBottom: '8px' }} />
                <div className="bonuestitle" style={{ fontSize: '11px', marginTop: '5px', lineHeight: '1.3' }}>Total Points Expired</div>
                  <div className="bonuevalue" style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '8px' }}>
                    🪙 {parseWalletAmount(UserActivity?.data?.total_points_expired).toFixed(2)}
                  </div>
                  <i style={{color:'white'}}>  →</i>
                </div>
              </Link>
            </div>

            {/* Right Box: Total APM Monthly Power Received */}
            <div className="col-4 mt-1">
              <div className="stat-box apm" style={{ padding: '12px', minHeight: '110px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <ChartNoAxesCombined size={28} color={'white'} style={{ marginBottom: '8px' }} />
                <div className="bonuestitle" style={{ fontSize: '11px', marginTop: '5px', lineHeight: '1.3' }}>Total APM Monthly Bonus</div>
                <div className="bonuevalue" style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '8px' }}>
                  🪙 {parseWalletAmount(UserActivity?.data?.apm_bonus).toFixed(2)}
                </div>
              </div>
            </div>
            <div className="col-12 mt-1">
              <Link to="/ExpiredPoints?scope=this_month" style={{ textDecoration: 'none' }}>
                <div className="stat-box bapm" style={{ padding: '12px', minHeight: '110px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', cursor: 'pointer' }}>
                  <CalendarClock size={28} color={'white'} style={{ marginBottom: '8px' }} />
                  <div className="bonuestitle" style={{ fontSize: '11px', marginTop: '5px', lineHeight: '1.3',textTransform: 'capitalize' }}>Coins Expiring/Expired in this month</div>
                  <div className="bonuevalue" style={{ fontSize: '15px', fontWeight: 'bold', marginTop: '8px' }}>
                    🪙 {parseWalletAmount(UserActivity?.data?.this_month_expiring_original ?? UserActivity?.data?.this_month_expried_cash).toFixed(2)}
                  </div>
                  <i style={{color:'white'}}>  →</i>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Notes Section */}
        <div className="section mt-2">
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '16px',
            padding: '20px',
            color: 'white',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
          }}>
            <h5 style={{
              color: 'white',
              marginBottom: '15px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ fontSize: '24px' }}>📋</span>
              Important Notes
            </h5>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '12px',
              padding: '15px',
              backdropFilter: 'blur(10px)'
            }}>
              <ul style={{
                margin: 0,
                paddingLeft: '20px',
                listStyle: 'none'
              }}>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span>Wallet is just the storage of reward points.</span>
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span>Customer cannot top-up the wallet with real money.</span>
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span>Wallet points do not carry any real money value.</span>
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span>Wallet points will be expired if not used / utilised before the specified time period.</span>
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span><strong>WELCOME BONUS</strong> reward points should be redeemed @ stores only.</span>
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span><strong>Welcome bonus</strong> cannot be used for Recharge / Credit Card bill payments.</span>
                </li>

                <li style={{
                  marginBottom: '12px',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span><strong>Referral bonus</strong> reward points can be used for, discount @ stores, bank account transfer, recharges, credit card bill payments etc.</span>
                </li>
                <li style={{
                  marginBottom: '0',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px'
                }}>
                  <span style={{ color: '#ffd700', fontSize: '18px', marginTop: '2px' }}>•</span>
                  <span><strong>Referral bonus</strong> reward points will be credited to the wallet, once the referred person does his first shopping through "APM Smart Hub" platform @ any one of our multiple stores/outlets.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* All Terms & Conditions Table */}
        <div className="section mt-2">
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '20px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            overflowX: 'auto'
          }}>
            <h5 style={{
              color: '#333',
              marginBottom: '20px',
              fontWeight: '600',
              fontSize: '18px',
              textAlign: 'center'
            }}>
              All Terms & Conditions
            </h5>

            {/* Mobile-Responsive Table */}
            <div className="terms-table-container" style={{
              width: '100%'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                minWidth: '600px',
                fontSize: '13px'
              }}>
                <thead>
                  <tr style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white'
                  }}>
                    <th style={{
                      padding: '12px 8px',
                      textAlign: 'left',
                      fontWeight: '600',
                      border: '1px solid rgba(255,255,255,0.2)',
                      fontSize: '12px'
                    }}>Sl. No.</th>
                    <th style={{
                      padding: '12px 8px',
                      textAlign: 'left',
                      fontWeight: '600',
                      border: '1px solid rgba(255,255,255,0.2)',
                      fontSize: '12px'
                    }}>Description</th>
                    <th style={{
                      padding: '12px 8px',
                      textAlign: 'left',
                      fontWeight: '600',
                      border: '1px solid rgba(255,255,255,0.2)',
                      fontSize: '12px'
                    }}>Result</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Rewards Points Expiry Time */}
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>1</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Rewards points expiry time</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      color: '#666',
                      fontSize: '11px'
                    }}>
                      {UserActivity?.data?.app_setting ? (
                        <>
                          Welcome: {UserActivity.data.app_setting.welcome_expried} days<br />
                          Referral: {UserActivity.data.app_setting.ref_expried} days<br />
                          Instant: {UserActivity.data.app_setting.instance_expried} days<br />
                          APM: {UserActivity.data.app_setting.apm_expried} days<br />
                          {/* Sunday: {UserActivity.data.app_setting.sunday_expried} days<br /> */}
                         Monthly Target: {UserActivity.data.app_setting.mile_expried} days
                        </>
                      ) : '-'}
                    </td>
                  </tr>

                  {/* Discount @ Stores Section */}
                  <tr>
                    <td colSpan="3" style={{
                      padding: '12px 8px',
                      border: '1px solid #e0e0e0',
                      background: '#f0f4ff',
                      fontWeight: '600',
                      color: '#667eea'
                    }}>T&C of Discount @ Stores/Purchase bills</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>2</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Minimum Required Reward points</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#28a745'
                    }}>₹ 1</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>3</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Maximum Reward points</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#dc3545'
                    }}>No Limits</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>4</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>How many times discount available per month</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#dc3545'
                    }}>Unlimited</td>
                  </tr>

                  {/* Recharges Section */}
                  <tr>
                    <td colSpan="3" style={{
                      padding: '12px 8px',
                      border: '1px solid #e0e0e0',
                      background: '#f0f4ff',
                      fontWeight: '600',
                      color: '#667eea'
                    }}>T&C of Recharges</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>5</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Minimum Reward points required</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#28a745'
                    }}>
                      ₹ {UserActivity?.data?.app_setting?.recharge_mini_amount || '0'}
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>6</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Maximum Reward Points</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#28a745'
                    }}>
                      ₹ {UserActivity?.data?.app_setting?.recharge_max_amount || '0'}
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>7</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>How many times Recharges can be done per month</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#dc3545'
                    }}>1</td>
                  </tr>

                  {/* Bank Transfer Section */}
                  

                  {/* Credit Card Bill Section */}
                  <tr>
                    <td colSpan="3" style={{
                      padding: '12px 8px',
                      border: '1px solid #e0e0e0',
                      background: '#f0f4ff',
                      fontWeight: '600',
                      color: '#667eea'
                    }}>T&C of Credit Card bill</td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>8</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Minimum Reward points required</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#28a745'
                    }}>
                      ₹ {UserActivity?.data?.app_setting?.recharge_mini_amount || '0'}
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>9</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>Maximum Reward points can be used for credit card bill payment</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#28a745'
                    }}>
                      Unlimited
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      fontWeight: '600',
                      background: '#f8f9fa',
                      verticalAlign: 'top'
                    }}>10</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top'
                    }}>How many times Credit card bill payment can be done per month</td>
                    <td style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      verticalAlign: 'top',
                      fontWeight: '600',
                      color: '#dc3545'
                    }}>1</td>
                  </tr>
                  <tr>
                    <td colSpan="3" style={{
                      padding: '10px 8px',
                      border: '1px solid #e0e0e0',
                      background: '#fff3cd',
                      fontSize: '12px',
                      color: '#856404'
                    }}>
                      <strong>Note:</strong> Credit Card bill payments can be paid only with the reward points available in the wallet.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Monthly Target Gate Pass T&C for APM MONTHLY BONUS */}
        <div className="section mt-2">
          <div style={{
            background: 'linear-gradient(135deg, #37a169 0%, #2d8659 100%)',
            borderRadius: '16px',
            padding: '20px',
            color: 'white',
            boxShadow: '0 4px 15px rgba(55, 161, 105, 0.3)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Decorative background pattern */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '200px',
              height: '200px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '150px',
              height: '150px',
              background: 'rgba(255, 255, 255, 0.08)',
              borderRadius: '50%',
              zIndex: 0
            }}></div>

            <div style={{ position: 'relative', zIndex: 1 }}>
              <h5 style={{
                color: 'white',
                marginBottom: '15px',
                fontWeight: '600',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '28px' }}>🎯</span>
                Monthly Target Gate Pass T&C for "APM MONTHLY BONUS"
              </h5>
              <div style={{
                background: 'rgba(255, 255, 255, 0.15)',
                borderRadius: '12px',
                padding: '15px',
                backdropFilter: 'blur(10px)',
                marginBottom: '15px'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: '12px',
                  color: '#ffd700',
                  fontWeight: '600',
                  fontStyle: 'italic'
                }}>
                  *T&C is for lifetime
                </p>
              </div>

              <div style={{
                background: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                padding: '15px',
                backdropFilter: 'blur(10px)'
              }}>
                <ul style={{
                  margin: 0,
                  paddingLeft: '20px',
                  listStyle: 'none'
                }}>
                  <li style={{
                    marginBottom: '15px',
                    fontSize: '14px',
                    lineHeight: '1.7',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                  }}>
                    <span style={{
                      color: '#ffd700',
                      fontSize: '20px',
                      marginTop: '2px',
                      fontWeight: 'bold'
                    }}>✓</span>
                    <span>
                      <strong>Flat 0.25% to 1%</strong> rewards points on total saved history for each <strong>monthly Target Gate Pass achievers</strong>.
                    </span>
                  </li>
                  <li style={{
                    marginBottom: '15px',
                    fontSize: '14px',
                    lineHeight: '1.7',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                  }}>
                    <span style={{
                      color: '#ffd700',
                      fontSize: '20px',
                      marginTop: '2px',
                      fontWeight: 'bold'
                    }}>✓</span>
                    <span>
                      <strong>Flat 0.01% to 0.1%</strong> rewards points on total saved history to <strong>Non monthly Target Gate Pass achievers</strong>.
                    </span>
                  </li>
                </ul>
              </div>

              <div style={{
                marginTop: '20px',
                padding: '15px',
                background: 'rgba(255, 255, 255, 0.25)',
                borderRadius: '12px',
                border: '2px dashed rgba(255, 255, 255, 0.5)',
                textAlign: 'center'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: '15px',
                  fontWeight: '600',
                  lineHeight: '1.6',
                  color: '#ffd700'
                }}>
                  📅 <strong>Henceforth, save 3rd of every following months in your Calendar as</strong>
                </p>
                <p style={{
                  margin: '8px 0 0 0',
                  fontSize: '16px',
                  fontWeight: '700',
                  lineHeight: '1.6',
                  color: '#ffffff',
                  textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                  "APM MONTHLY BONUS Day"
                </p>
                <p style={{
                  margin: '8px 0 0 0',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '1.6',
                  color: '#ffffff'
                }}>
                  and earn unstoppable rewards points for lifetime! 🚀
                </p>
                <p>(Only For Active Subscribed Members)</p>
              </div>
            </div>
          </div>
        </div>

        <div className="section  mt-2">
          <div className="row">
            {/* <div className="col-6">
              <Link to={`/Instant`} >
                <div className="stat-box insta align-items-center justify-center">
                  <Landmark size={30} color={'white'} />
                  <div className="bonuestitle">Shopping Day Bonus</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.instant_bonus}</div>
                </div>
              </Link>
            </div>

            <div className="col-6">
              <Link to={`/Apm`} >
                <div className="stat-box apm">
                  <ChartNoAxesCombined size={30} color={'white'} />

                  <div className="bonuestitle">APM Bonus</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.apm_bonus}</div>
                </div>
              </Link>
            </div> */}

            {/* Hidden: Total Received Points Card */}
            {/* {(UserActivity?.data?.sunday_bonus_enabled !== 0) && (
            <div className="col-6 mt-1">
              <Link to={`/Sundaybonus`} >
                <div className="stat-box sundaybonues align-items-center justify-center">
                  <Star size={30} color={'white'} />
                  <div className="bonuestitle">Total Received Points</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.sunday_bonus}</div>
                </div>
              </Link>
            </div>
            )} */}

            {/* <div className="col-6 mt-1">
              <Link to={`/Sundaybonus`} >
                <div className="stat-box sundaybonues align-items-center justify-center">
                  <Star size={30} color={'white'} />
                  <div className="bonuestitle">Sunday Bonus</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.sunday_bonus}</div>
                </div>
              </Link>
            </div> */}

            {/* Hidden: Expired Points Card */}
            {/* <div className="col-6 mt-1">
              <Link to={`/Bills`} >
                <div className="stat-box billamountbonues">
                  <ReceiptIndianRupee size={30} color={'white'} />

                  <div className="bonuestitle">Expired Points</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.expried_cash}</div>
                </div>
              </Link>
            </div> */}

            {/* <div className="col-6 mt-1">
              <Link to={`/Suspendedbonus`} >
                <div className="stat-box suspended_bonus align-items-center justify-center">
                  <CalendarClock size={30} color={'white'} />
                  <div className="bonuestitle">Rewards Expired</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.suspended_bonus}</div>
                </div>
              </Link>
            </div> */}
            {/* <div className="col-6 mt-1">
              <Link to={`/Referral`} >
                <div className="stat-box refbonues">
                  <Handshake size={30} color={'white'} />

                  <div className="bonuestitle">Referral welcome bonus</div>
                  <div className="bonuevalue">🪙 {UserActivity?.data?.ref_wel}</div>
                </div>
              </Link>
            </div> */}
          </div>
        </div>
        {/* Hidden: Mile Stone Card */}
        {/* <div className='section mt-2'>
          {games.map((game, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 * index }}
            >
              <Card className="mb-3   mpin" >
                <Card.Body className=" justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-3">
                    <img src={game.icon} alt={game.name} style={{ width: '100px', height: '100px' }} className="rounded" />
                      <div>
                      </div>
                      </div>
                  <div className=" mt-2">
                    <div className="">
                      <div className="row mb-05 fontsize-sub">
                        <div className="col text-white"><strong>🪙{UserActivity?.data?.mile_stone_details.billamount}</strong></div>
                        <div className="col text-secondary text-end"></div>
                    </div>
                      <div className="progress">
                        <div className="progress-bar bg-success" role="progressbar" style={{ width: UserActivity?.data?.mile_stone_details?.percentage + '%', height: 'auto' }} aria-valuenow={UserActivity?.data?.mile_stone_details?.percentage} aria-valuemin={0} aria-valuemax={100} />
                        <div className="progress-bar bg-secondary" role="progressbar" style={{ width: '0%' }} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} />
                    </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </motion.div>
          ))}
        </div> */}

        <div className="section mt-2">
          {user && (
            <div className="mt-3 mb-3">
              <h5>Refer and earn</h5>
              <a
                onClick={shareReferralLink}
                style={{ cursor: 'pointer', display: 'block' }}
              >
                <img
                  style={{ width: '100%', height: '100px', borderRadius: '16px' }}
                  src='https://archliteassignment.co.uk/wp-content/uploads/2022/10/Refer-earn-banner.png'
                  alt="Refer and Earn"
                />
              </a>
            </div>
          )}

        </div>

        {/* Withdrawal History Section */}
        <div className="section mt-4">
          <div className="section-heading d-flex justify-content-between align-items-center">
            <h2 className="title">Withdrawal History</h2>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowWithdrawHistory(!showWithdrawHistory)}
            >
              {showWithdrawHistory ? 'Hide' : 'Show'} History
            </Button>
          </div>
          {showWithdrawHistory && (
            <div className="transactions" style={{ marginBottom: '2%' }}>
              {withdrawalHistory.length > 0 ? (
                withdrawalHistory.map((withdrawal, index) => (
                  <div key={index} className="item" style={{
                    padding: '15px',
                    marginBottom: '10px',
                    background: '#f8f9fa',
                    borderRadius: '12px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <div className="detail">
                      <div>
                        <strong>Withdrawal Request #{withdrawal.id}</strong>
                        <span style={{ display: 'block', fontSize: '12px', color: '#666' }}>
                          {FormatDate(withdrawal.created_at)}
                        </span>
                        <p>
                          <span className={`badge ${withdrawal.status === 'pending' ? 'badge-warning' :
                            withdrawal.status === 'approved' ? 'badge-success' :
                              withdrawal.status === 'rejected' ? 'badge-danger' : 'badge-secondary'
                            }`}>
                            {withdrawal.status?.toUpperCase() || 'PENDING'}
                          </span>
                        </p>
                        {withdrawal.bank_account && (
                          <small style={{ display: 'block', color: '#666', marginTop: '5px' }}>
                            Account: ****{withdrawal.bank_account.slice(-4)} | IFSC: {withdrawal.ifsc_code}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="right">
                      <div className="price text-success">₹{parseFloat(withdrawal.amount || 0).toFixed(2)}</div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center p-4" style={{ color: '#999' }}>
                  No withdrawal history found
                </div>
              )}
            </div>
          )}
        </div>

        <div className="section mt-4">
          <div className="section-heading">
            <h2 className="title">Transactions</h2>

          </div>
          <div className="transactions" style={{ marginBottom: '5%' }}>
            {UserActivity?.data?.billlist.map((shop, index) => (
              <Link state={{ shop }} to={'/Billdetails'} className="item">
                <div className="detail">
                  <img
                    src="assets/img/sample/brand/order.png"
                    alt="img"
                    className="image-block imaged w48"
                  />
                  <div>
                    <strong>Order Id:{shop.id} </strong>
                    <span>{FormatDate(shop.date_time || shop.created_at)}</span>
                    <p><span className='text-danger'><b>{shop.paytype}</b></span> / 
                    {shop.is_paid == 1 ? <span className='badge badge-danger'>Unpaid</span> 
    : shop.is_paid == 2 ? <span className='badge badge-warning'>Cancelled</span> 
    : <span className='badge badge-success'>Paid</span>
}</p>                  </div>
                </div>
                <div className="right">
                  <div className="price text-danger">₹{shop.totalbillamount}</div>
                </div>
              </Link>
            ))}

          </div>
        </div>
        {/* MY WALLET Section - Hidden till Rewards points Expiry feature is ready */}
        {/* <div className='p-2 mb-5' >
        <center>
          <img src="./app_logo.png" style={{ width: '150px', height: '150px' }} />
        </center>
        <div class="text-center mb-0 mt-2">
      <h2 class="wallet-title">MY WALLET</h2>
    </div>
    <div class="row text-center mb-2">
      <div class="col-12">
        <div class="wallet-box">
          <h4>Reward Points Wallet</h4>
          <p><strong>Lifetime Earned: ₹{parseFloat(UserActivity?.data?.lifetime_total || UserActivity?.data?.account_1 || 0).toFixed(2)}</strong></p>
          <p><strong>Available for Redemption: ₹{parseFloat(UserActivity?.data?.wallet_balance || UserActivity?.data?.redemption_total || 0).toFixed(2)}</strong></p>
          <p style={{marginTop: '10px', fontSize: '18px', fontWeight: 'bold'}}>Wallet: ₹{parseFloat(UserActivity?.data?.wallet_balance || UserActivity?.data?.redemption_total || 0).toFixed(2)}</p>
          <hr style={{margin: '10px 0'}} />
          <p style={{fontSize: '14px', color: '#666'}}><em>Total Lifetime Bonuses Earned: ₹{parseFloat(UserActivity?.data?.lifetime_total || 0).toFixed(2)}</em></p>
        </div>
      </div>
    </div>
    <div class="wallet-box mb-2">
      <h5 class="wallet-title">Redemption Options</h5>
      <ul>
        <li><strong>Wallet 1:</strong> Discount @ Stores only</li>
        <li><strong>Wallet 2:</strong>
          <ul>
            <li>Discount @ Stores</li>
            <li>Payout to Bank Account (Min ₹{UserActivity?.data?.mini_withdrawal || 10})</li>
            <li>Mobile/DTH Recharge (Min ₹10)</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="wallet-box mb-2">
      <h5 class="wallet-title">Rewards points Storage</h5>
      <div class="row">
        <div class="col-6">
          <ul>
            <li>Welcome Rewards points (App Download)</li>
            <li>Referral Rewards points</li>
            {(UserActivity?.data?.sunday_bonus_enabled !== 0) && (
            <li>Sunday/Weekly Rewards points</li>
            )}
          </ul>
        </div>
        <div class="col-6">
          <ul>
            <li>Shopping Day Rewards points</li>
            <li>APM Add-on Reward Points (7th of every month)</li>
            <li>Milestone Gifts & Vouchers</li>
            <li>Overflow Reward Points</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="wallet-box">
      <h5 class="wallet-title">Rewards points Expiry</h5>
      <ul>
        <li><strong>Welcome Rewards points wallet:</strong> 30 days</li>
        <li><strong>Rewards points wallet:</strong> 100 days</li>
      </ul>
    </div>
        </div> */}
       
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Payment Request</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '60px',
                height: '60px',
                background: '#ff8f00',
                borderRadius: '50%',
                border: '2px solid white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IndianRupee size={30} color="white" />
            </div>
            <p style={{ marginTop: '10px' }}>
              {paymentdetails?.shop_name} - {paymentdetails?.phone}
            </p>
            <h2 style={{ marginTop: '10px', fontWeight: 'bold' }}>₹{paymentdetails?.billamount}</h2>
            {(parseWalletAmount(UserActivity?.data?.wallet_balance || UserActivity?.data?.redemption_total)) > 0 && (
              <div className="form-check mt-3" style={{ background: '#f8f9fa', padding: '15px 15px 15px 35px', borderRadius: '12px', border: '1px solid #e9ecef', width: '100%' }}>
                <input
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  type="checkbox"
                  className="form-check-input"
                  id="activityRewardCheck"
                  style={{ width: '20px', height: '20px', marginTop: '2px' }}
                />
                <label className="form-check-label ms-1" htmlFor="activityRewardCheck" style={{ fontWeight: '600', color: '#333' }}>
                  Use Reward Points Wallet ₹{parseWalletAmount(UserActivity?.data?.wallet_balance || UserActivity?.data?.redemption_total).toFixed(2)}
                </label>
                {UserActivity?.data?.welcome_bonus_used == 1 && (
                  <div className="alert alert-warning mt-2 mb-0" role="alert" style={{ fontSize: '11px', padding: '6px', borderRadius: '6px' }}>
                    ⚠️ Welcome bonus has already been used.
                  </div>
                )}
              </div>
            )}


          </div>


        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={makePayment}>
            Confirm  <Banknote size={20} color="white" />
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={welcomeShow} onHide={() => setwelcomeShow(false)} centered>
        <Modal.Header >

        </Modal.Header>
        <Modal.Body >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Player
              src='assets/lottiefiles/Animation - 1744456150479.json'
              autoplay
              style={{ height: '300px', width: '300px' }}
              loop
            />
            <h3>You get ₹{UserActivity?.data.welcome_bonus_new} as a welcome bonus!</h3>
          </div>


        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={() => setwelcomeShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Withdrawal Modal */}
      <Modal show={Withdraw} onHide={() => {
        setWithdraw(false);
        setWithdrawAmount('');
        if (!useSavedDetails) {
          setBankAccount('');
          setIfscCode('');
          setAccountHolderName('');
          setUpiId('');
        }
      }} centered size="lg">
        <Modal.Header>
          <Modal.Title>Points to Bank Account/UPI : <br></br>Coming Soon from  August 2026</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div>
            <div className="alert alert-info" role="alert" style={{ fontSize: '13px' }}>
              <strong>Available Balance:</strong> ₹{parseFloat(UserActivity?.data?.redemption_total || 0).toFixed(2)}<br />
              <small className="text-secondary" style={{ fontSize: '11px' }}>
                (Wallet 1: ₹{parseWalletAmount(UserActivity?.data?.wallet_1 ?? UserActivity?.data?.welcome_bonus_val).toFixed(2)} + Wallet 2: ₹{parseWalletAmount(UserActivity?.data?.wallet_2 ?? UserActivity?.data?.account_2_val).toFixed(2)})
              </small><br />
              <strong>Minimum Withdrawal:</strong> ₹{parseFloat(UserActivity?.data?.mini_withdrawal || 10).toFixed(2)}
            </div>

            {(UserActivity?.data?.mini_withdrawal > UserActivity?.data?.redemption_total) ? (
              <div className="alert alert-danger" role="alert">
                The minimum withdrawal amount is ₹{UserActivity?.data?.mini_withdrawal}. Your total redemption balance is too low.
              </div>
            ) : (
              <>
                <div className="form-group mb-3">
                  <label htmlFor="withdrawAmount"><strong>Withdrawal Amount (₹)</strong></label>
                  <input
                    type="number"
                    className="form-control"
                    id="withdrawAmount"
                    placeholder="Enter Amount"
                    value={withdrawAmount}
                    onChange={(e) => setWithdrawAmount(e.target.value)}
                    min={UserActivity?.data?.mini_withdrawal || 10}
                    max={UserActivity?.data?.redemption_total || 0}
                    step="0.01"
                  />
                  <small className="text-muted">
                    You can withdraw up to ₹{parseFloat(UserActivity?.data?.redemption_total || 0).toFixed(2)}
                  </small>
                </div>

                {bankDetails && (
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="useSavedDetails"
                      checked={useSavedDetails}
                      onChange={(e) => {
                        setUseSavedDetails(e.target.checked);
                        if (e.target.checked && bankDetails) {
                          if (bankDetails.preferred_method === 'bank') {
                            setAccountHolderName(bankDetails.account_holder_name || '');
                            setBankAccount(bankDetails.bank_account || '');
                            setIfscCode(bankDetails.ifsc_code || '');
                            setPreferredMethod('bank');
                          } else {
                            setUpiId(bankDetails.upi_id || '');
                            setPreferredMethod('upi');
                          }
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="useSavedDetails">
                      Use saved bank/UPI details
                    </label>
                    {bankDetails.preferred_method === 'bank' && (
                      <div className="mt-2 p-2 bg-light rounded">
                        <small>
                          <strong>Saved:</strong> {bankDetails.account_holder_name} |
                          Account: ****{bankDetails.bank_account?.slice(-4)} |
                          IFSC: {bankDetails.ifsc_code}
                        </small>
                      </div>
                    )}
                    {bankDetails.preferred_method === 'upi' && (
                      <div className="mt-2 p-2 bg-light rounded">
                        <small>
                          <strong>Saved UPI:</strong> {bankDetails.upi_id}
                        </small>
                      </div>
                    )}
                  </div>
                )}

                {!useSavedDetails && (
                  <>
                    <div className="form-group mb-3">
                      <label><strong>Payout Method</strong></label>
                      <div>
                        <Form.Check
                          type="radio"
                          label="Bank Account"
                          name="payoutMethod"
                          id="bankMethod"
                          checked={preferredMethod === 'bank'}
                          onChange={() => setPreferredMethod('bank')}
                          className="mb-2"
                        />
                        <Form.Check
                          type="radio"
                          label="UPI"
                          name="payoutMethod"
                          id="upiMethod"
                          checked={preferredMethod === 'upi'}
                          onChange={() => setPreferredMethod('upi')}
                        />
                      </div>
                    </div>

                    {preferredMethod === 'bank' ? (
                      <>
                        <div className="form-group mb-3">
                          <label htmlFor="accountHolderName"><strong>Account Holder Name *</strong></label>
                          <input
                            type="text"
                            className="form-control"
                            id="accountHolderName"
                            placeholder="Enter Account Holder Name"
                            value={accountHolderName}
                            onChange={(e) => setAccountHolderName(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label htmlFor="bankAccount"><strong>Bank Account Number *</strong></label>
                          <input
                            type="text"
                            className="form-control"
                            id="bankAccount"
                            placeholder="Enter Bank Account Number"
                            value={bankAccount}
                            onChange={(e) => setBankAccount(e.target.value.replace(/\D/g, ''))}
                            required
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label htmlFor="ifscCode"><strong>IFSC Code *</strong></label>
                          <input
                            type="text"
                            className="form-control"
                            id="ifscCode"
                            placeholder="Enter IFSC Code"
                            value={ifscCode}
                            onChange={(e) => setIfscCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''))}
                            maxLength={11}
                            required
                          />
                        </div>
                      </>
                    ) : (
                      <div className="form-group mb-3">
                        <label htmlFor="upiId"><strong>UPI ID *</strong></label>
                        <input
                          type="text"
                          className="form-control"
                          id="upiId"
                          placeholder="Enter UPI ID (e.g., name@paytm)"
                          value={upiId}
                          onChange={(e) => setUpiId(e.target.value.toLowerCase())}
                          required
                        />
                      </div>
                    )}
                  </>
                )}

                {!bankDetails && (
                  <div className="alert alert-warning" role="alert">
                    <small>
                      <strong>Tip:</strong> Save your bank/UPI details in <Link to="/BankDetails" onClick={() => setWithdraw(false)}>Bank/UPI Details</Link> for faster withdrawals.
                    </small>
                  </div>
                )}

                <div className="alert alert-info mt-3" role="alert">
                  <small>
                    <strong>Note:</strong> Withdrawal requests will be processed within 3-5 business days.
                    Please ensure all details are correct.
                  </small>
                </div>
              </>
            )}
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setWithdraw(false);
            setWithdrawAmount('');
            if (!useSavedDetails) {
              setBankAccount('');
              setIfscCode('');
              setAccountHolderName('');
              setUpiId('');
            }
          }}>
            Cancel
          </Button>
          {(parseWalletAmount(UserActivity?.data?.mini_withdrawal, 10) <= parseWalletAmount(UserActivity?.data?.redemption_total ?? UserActivity?.data?.wallet_balance)) && (
            <Button variant="primary" onClick={handleWithdrawal}>
              Submit Withdrawal Request
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Logout on Another Device Modal */}
      <Modal
        show={showLogoutModal}
        onHide={() => { }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="justify-content-center">
          <Modal.Title className="text-danger">Session Conflict</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mb-3">
            <ion-icon name="alert-circle-outline" style={{ fontSize: '60px', color: '#dc3545' }}></ion-icon>
          </div>
          <h4>You have been logged out</h4>
          <p>
            Your account was just logged in on another device.
            To protect your security, only one active session is allowed at a time.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="danger"
            className="btn-block"
            onClick={() => {
              localStorage.removeItem('access_token');
              localStorage.removeItem('device_token');
              window.location.href = '/signin';
            }}
          >
            OK, Sign in again
          </Button>
        </Modal.Footer>
      </Modal>
    </>

  )
}

export default Index